import { DateTime } from 'luxon';

import { Payload, BaseResult } from '../types';

const formatDeviceTimezone = (hours: number): string => {
    if (!Number.isFinite(hours)) return '+00:00';
    const sign = hours >= 0 ? '+' : '-';
    const formatted = DateTime.utc(0)
        .plus({ hours: Math.abs(hours) })
        .toFormat('HH:mm');
    return sign + formatted;
};

export const mapBase = (payload: Payload): BaseResult => ({
    session_id: payload.payload.sessionId,
    timestamp_initiated: DateTime.fromMillis(payload.payload?.timestamp)
        .toUTC()
        .toFormat("yyyy-MM-dd'T'HH:mm:ss'+00:00'"),
    device_id: payload.deviceId,
    device_type: payload.deviceType,
    device_appversion: payload.appVersion,
    device_model: payload.deviceModel,
    device_platform: payload.platform,
    device_manufacturer: payload.deviceManufacturer,
    device_timezone: formatDeviceTimezone(payload.deviceTimeZone),
    service_id: payload.serviceId,
    user_id: payload.userId,
    user_email: payload?.payload?.isTrackingAllowed ? payload.payload.user?.email ?? '' : '',
    ad_targeting_allowed: payload?.payload.isAdTargetingAllowed,
    attribution_id:
        payload.payload?.asset?.attributionId ||
        payload.payload?.params?.attributionId ||
        payload.payload?.params?.asset?.attributionId ||
        '', // return empty string if value not present
    user_profile_id: payload.userProfileId,
    custom_campaign_url: payload.payload?.campaignUrl || '',
    custom_meta_fbc: payload.payload?.campaignCookie || '',
    ...(!payload.userId && { user_id: payload.deviceId }),
});
